import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "max-w-[50%]"
}
const _hoisted_3 = { class: "inline ml-[70px]" }
const _hoisted_4 = { class: "md:mb-[30px]" }
const _hoisted_5 = { class: "scrollDates" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = {
  key: 0,
  class: "divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChTypography = _resolveComponent("ChTypography")!
  const _component_ChButton = _resolveComponent("ChButton")!
  const _component_ch_accordion_item = _resolveComponent("ch-accordion-item")!
  const _component_ch_accordion = _resolveComponent("ch-accordion")!
  const _component_ch_modal = _resolveComponent("ch-modal")!
  const _component_ch_loader = _resolveComponent("ch-loader")!

  return (!_ctx.loading)
    ? (_openBlock(), _createBlock(_component_ch_modal, {
        key: 0,
        classNames: 
      _ctx.isMobile
        ? '!min-w-fit !w-auto top-[32%] translate-x-[-4%] text-left'
        : 'max-h-[614px] max-w-[744px] absolute left-[50%] translate-y-[-50%] translate-x-[-50%] positioning top-[50%] text-left'
    ,
        dividers: true,
        borderGradient: false,
        allowOutsideClick: true,
        title: _ctx.t('home.suggested-courses.modal.title', { course: _ctx.modalInfo?.name }),
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass({ 'flex justify-between': !_ctx.isMobile })
          }, [
            (_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_ch_accordion, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ch_accordion_item, { class: "py-0 !border-y-0" }, {
                        title: _withCtx(() => [
                          _createVNode(_component_ChTypography, {
                            "as-tag": "h3",
                            variant: "Untitled16Medium",
                            class: "text-white md:mb-[30px]"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('products.modal.about')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        content: _withCtx(() => [
                          _createVNode(_component_ChTypography, {
                            "as-tag": "p",
                            variant: "Untitled14Regular",
                            class: "text-white max-w-[80%]"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.modalInfo?.description), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ChTypography, {
                            "as-tag": "p",
                            variant: "Untitled14Regular",
                            class: "text-white mt-[50px]"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('products.modal.dedication') + ' ' + _ctx.modalInfo?.dedication), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ChButton, {
                            class: "mt-[20px]",
                            "button-variant": "tertiary",
                            size: "small",
                            disabled: _ctx.disabledButton,
                            label: _ctx.t('products.modal.program'),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enrollUser(_ctx.modalInfo?.program)))
                          }, null, 8, ["disabled", "label"]),
                          _createVNode(_component_ChTypography, {
                            "as-tag": "p",
                            variant: "Untitled16Regular",
                            class: "font-bold text-white"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.isThereAvailableBalanceWithCurrency ? _ctx.t('products.modal.available-balance') + _ctx.userAvailableBalanceAlias : ''), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ChTypography, {
                            "as-tag": "p",
                            variant: "Untitled12Regular",
                            class: "font-bold text-green-dark"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.isThereFreePurchase ? _ctx.t('products.model.available-balance-free-courser') : ''), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_ChTypography, {
                    "as-tag": "h3",
                    variant: "Untitled16Medium",
                    class: "text-white mb-[30px]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('products.modal.about')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ChTypography, {
                    "as-tag": "p",
                    variant: "Untitled14Regular",
                    class: "text-white 2xl:max-w-[80%]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.modalInfo?.description), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ChTypography, {
                    "as-tag": "p",
                    variant: "Untitled14Regular",
                    class: "text-white mt-[50px]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('products.modal.dedication') + ' ' + _ctx.modalInfo?.dedication), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ChButton, {
                    class: "mt-[20px] mb-[20px]",
                    "button-variant": "tertiary",
                    size: "small",
                    disabled: _ctx.disabledButton,
                    label: _ctx.t('products.modal.program'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enrollUser(_ctx.modalInfo?.program)))
                  }, null, 8, ["disabled", "label"]),
                  _createVNode(_component_ChTypography, {
                    "as-tag": "p",
                    variant: "Untitled16Regular",
                    class: "font-bold text-white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isThereAvailableBalanceWithCurrency ? _ctx.t('products.modal.available-balance') + ' ' + _ctx.userAvailableBalanceAlias : ''), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ChTypography, {
                    "as-tag": "p",
                    variant: "Untitled12Regular",
                    class: "font-bold text-green-dark"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isThereFreePurchase ? _ctx.freePurchaseAlias : ''), 1)
                    ]),
                    _: 1
                  })
                ])),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_ChTypography, {
                  "as-tag": "h3",
                  variant: "Untitled16Medium",
                  class: "text-white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('ch-modal-request-reenroll.next-dates')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalInfo?.dates, (date) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: date._id,
                    class: "w-[300px] mt-[10px] mr-[20px]"
                  }, [
                    _createVNode(_component_ChTypography, {
                      "as-tag": "p",
                      variant: "Untitled12Regular",
                      class: "text-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(date.startDate) + ` ${_ctx.t('ch-modal-request-reenroll.to')} ` + _ctx.formatDate(date.endDate)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ChTypography, {
                      "as-tag": "p",
                      variant: "Untitled12Regular",
                      class: "text-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDays(date.days)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_ChTypography, {
                        "as-tag": "p",
                        variant: "Untitled12Regular",
                        class: "text-white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('products.suggested-courses.modal.course-hours', {
                    startHour: _ctx.formatTime(date.startHour),
                    endHour: _ctx.formatTime(date.endHour)
                  })), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ChButton, {
                        class: "!px-[0px] mr-[10px]",
                        "button-variant": "link",
                        size: "small",
                        label: _ctx.t('products.product.btn-enroll'),
                        disabled: _ctx.disabledButton,
                        onClick: ($event: any) => (_ctx.enrollUser(date?.linkPurchase))
                      }, null, 8, ["label", "disabled", "onClick"])
                    ]),
                    (date != _ctx.modalInfo.dates.at(-1))
                      ? (_openBlock(), _createElementBlock("hr", _hoisted_7))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["classNames", "title", "onClose"]))
    : (_openBlock(), _createBlock(_component_ch_loader, {
        key: 1,
        class: "fixed"
      }))
}